import { useState } from 'react';
import { convertNumberPersianToEnglish } from '@helper/functions';
import BtnCheckBox from '../../BtnCheckBox/BtnCheckBox';
import { patternTelInput } from '@helper/functions';

export default function Step2({ formikSignUpRealestate, setStep }) {
  const MAX_IMAGE_SIZE_MB = 5;
  const [selectedImages, setSelectedImages] = useState(null);

  const data = [
    { name: 'به نام خودم', nameEn: 'me' },
    { name: 'به نام دیگری', nameEn: 'other' },
  ];

  const selectHandler = (e) => {
    e.preventDefault();
    formikSignUpRealestate.setFieldValue('statusBusinessLicense', e.target.value);
  };

  const handleDivClick = () => {
    document.getElementById('logo').click();
  };

  const handleFileChange = (e) => {
    const files = e.target.files;
    if (files) {
      if (!(files[0].type === 'image/jpg' || files[0].type === 'image/jpeg' || files[0].type === 'image/png')) {
        formikSignUpRealestate.setErrors({
          ...formikSignUpRealestate.errors,
          logo: 'فرمت فایل باید یکی از این موارد باشد : (png , jpg , jpeg)',
        });
      } else if (files[0].size >= MAX_IMAGE_SIZE_MB * 1024 * 1024) {
        formikSignUpRealestate.setErrors({
          ...formikSignUpRealestate.errors,
          logo: `تصویر ${files[0].name} حجم بیشتر از ${MAX_IMAGE_SIZE_MB} مگابایت دارد.`,
        });
      } else {
        setSelectedImages(files[0]);
        formikSignUpRealestate.setFieldValue('logo', files[0]);
      }
    }
  };

  const handleChangeNumber = (e) => {
    const { name, value } = e.target;
    const englishValue = convertNumberPersianToEnglish(value);
    formikSignUpRealestate.setFieldValue(name, englishValue);
  };

  return (
    <form
      onSubmit={formikSignUpRealestate.handleSubmit}
      className="grid grid-cols-2 lg:grid-cols-3 gap-x-4 gap-y-8 lg:gap-x-6 lg:gap-y-12 w-full max-w-[550px]"
    >
      <div className="flex items-center relative gap-4 col-span-2 lg:col-span-3 w-full">
        <label className="text-sm lg:text-base whitespace-nowrap" htmlFor="">
          وضعیت پروانه کسب
        </label>
        {/* <input
          name="firstName"
          onChange={formikSignUpRealestate.handleChange}
          onBlur={formikSignUpRealestate.handleBlur}
          value={formikSignUpRealestate.values.firstName}
          dir="rtl"
          className={`w-full rounded-lg border-[1.5px] ${
            formikSignUpRealestate.errors.firstName &&
            formikSignUpRealestate.touched.firstName
              ? "border-error"
              : "border-blackFont-200 focus:border-blackFont-900"
          } py-2 px-4 flex items-center justify-between overflow-hidden transition-all placeholder:font-light`}
          placeholder="مثال : امیر رضا"
          type="text"
        /> */}
        <div className="w-full flex flex-wrap items-center gap-3">
          {data.map((item, index) => (
            <BtnCheckBox
              key={item.nameEn}
              nameEn={item.nameEn}
              name={item.name}
              selectHandler={selectHandler}
              logic={formikSignUpRealestate.values.statusBusinessLicense == item.nameEn}
              color="primary"
            />
          ))}
        </div>
        <span
          className={`text-[12px] text-error absolute -bottom-[22px] transition-all ${
            formikSignUpRealestate.errors.statusBusinessLicense && formikSignUpRealestate.touched.statusBusinessLicense
              ? 'visible opacity-100'
              : 'invisible opacity-0'
          }`}
        >
          {formikSignUpRealestate.errors.statusBusinessLicense}
        </span>
      </div>
      <div className="flex flex-col relative gap-1 col-span-2 lg:col-span-1">
        <label className="text-sm lg:text-base" htmlFor="">
          نام آژانس
        </label>
        <input
          name="nameAgency"
          onChange={formikSignUpRealestate.handleChange}
          onBlur={formikSignUpRealestate.handleBlur}
          value={formikSignUpRealestate.values.nameAgency}
          dir="rtl"
          className={`w-full rounded-lg border-[1.5px] ${
            formikSignUpRealestate.errors.nameAgency && formikSignUpRealestate.touched.nameAgency
              ? 'border-error'
              : 'border-blackFont-200 focus:border-blackFont-900'
          } py-2 px-4 flex items-center justify-between overflow-hidden transition-all placeholder:font-light`}
          placeholder="مثال : پنل"
          type="text"
        />
        <span
          className={`text-[12px] text-error absolute -bottom-[22px] transition-all ${
            formikSignUpRealestate.errors.nameAgency && formikSignUpRealestate.touched.nameAgency
              ? 'visible opacity-100'
              : 'invisible opacity-0'
          }`}
        >
          {formikSignUpRealestate.errors.nameAgency}
        </span>
      </div>
      <div className="flex flex-col relative gap-1 col-span-1 lg:col-span-1">
        <label className="text-sm lg:text-base" htmlFor="">
          تلفن ثابت
        </label>
        <input
          name="telAgency"
          onChange={handleChangeNumber}
          onBlur={formikSignUpRealestate.handleBlur}
          value={formikSignUpRealestate.values.telAgency}
          dir="rtl"
          className={`w-full rounded-lg border-[1.5px] ${
            formikSignUpRealestate.errors.telAgency && formikSignUpRealestate.touched.telAgency
              ? 'border-error'
              : 'border-blackFont-200 focus:border-blackFont-900'
          } py-2 px-4 flex items-center justify-between overflow-hidden transition-all placeholder:font-light`}
          placeholder="مثال : 0212478896"
          type="tel"
          onInput={patternTelInput}
        />
        <span
          className={`text-[12px] text-error absolute -bottom-[22px] transition-all whitespace-nowrap ${
            formikSignUpRealestate.errors.telAgency && formikSignUpRealestate.touched.telAgency
              ? 'visible opacity-100'
              : 'invisible opacity-0'
          }`}
        >
          {formikSignUpRealestate.errors.telAgency}
        </span>
      </div>
      <div className="flex flex-col relative gap-1 col-span-1 lg:col-span-1">
        <label className="text-sm lg:text-base" htmlFor="">
          شناسه صنفی
        </label>
        <input
          name="tradeID"
          onChange={handleChangeNumber}
          onBlur={formikSignUpRealestate.handleBlur}
          value={formikSignUpRealestate.values.tradeID}
          dir="rtl"
          className={`w-full rounded-lg border-[1.5px] ${
            formikSignUpRealestate.errors.tradeID && formikSignUpRealestate.touched.tradeID
              ? 'border-error'
              : 'border-blackFont-200 focus:border-blackFont-900'
          } py-2 px-4 flex items-center justify-between overflow-hidden transition-all placeholder:font-light`}
          placeholder="باید 10 رقم باشد"
          type="tel"
          onInput={patternTelInput}
        />
        <span
          className={`text-[12px] text-error absolute -bottom-[22px] transition-all whitespace-nowrap ${
            formikSignUpRealestate.errors.tradeID && formikSignUpRealestate.touched.tradeID
              ? 'visible opacity-100'
              : 'invisible opacity-0'
          }`}
        >
          {formikSignUpRealestate.errors.tradeID}
        </span>
      </div>
      <div className="flex flex-col relative gap-1 col-span-2 lg:col-span-3">
        <label className="text-sm lg:text-base" htmlFor="">
          تصویر لوگو
        </label>
        <div className="flex items-end justify-between">
          <div className="flex flex-col gap-3">
            <span className="md:text-sm text-blackFont-600 md:leading-8 leading-7 text-xs">
              این تصویر بر روی پروفایل آژانس شما
              <br className="md:hidden" /> درج خواهد شد <br />
              (حداکثر
              {MAX_IMAGE_SIZE_MB} مگابایت)
            </span>
            {/* <span>فایل را به داخل کادر بکشید</span> */}
            <div
              className="px-4 py-2 text-sm flex justify-center items-center text-primary border-[1px] border-primary w-fit rounded-lg cursor-pointer"
              onClick={handleDivClick}
            >
              <input
                name="logo"
                className="hidden"
                type="file"
                accept="image/png, image/jpeg, image/jpg"
                id="logo"
                multiple={false}
                onChange={handleFileChange}
              />
              {/* <img src="/assets/images/upload (1).svg" /> */}
              <span>انتخاب تصویر</span>
            </div>
          </div>
          {formikSignUpRealestate.values.logo ? (
            <div className="w-28 h-28 md:w-36 md:h-36 relative group transition-all border-2 border-grayColor p-2 rounded-lg flex items-center justify-center">
              <img
                className="w-full h-full rounded-md overflow-hidden object-cover"
                src={URL.createObjectURL(formikSignUpRealestate.values.logo)}
                alt={formikSignUpRealestate.values.logo}
              />
              {/* <div className="absolute md:hidden md:group-hover:block p-2 top-0 w-full h-full transition-all rounded-md">
                <div className="flex w-full h-full bg-black/30 gap-3 items-center justify-center transition-all rounded-md"> */}
              {/* <img
                    className="w-6 h-auto cursor-pointer"
                    src="/assets/images/DeleteOutlined.svg"
                   
                    onClick={() => handleDeleteImage(index)}
                  /> */}
              {/* <img
                        className="w-6 h-auto cursor-pointer"
                        src="/assets/images/Eye.svg"
                       
                        onClick={() => handleOpenImage(index)}
                      /> */}
              {/* </div> */}
              {/* </div> */}
            </div>
          ) : null}
        </div>
        <span
          className={`text-[12px] text-error absolute -bottom-[22px] transition-all ${
            formikSignUpRealestate.errors.logo && formikSignUpRealestate.touched.logo
              ? 'visible opacity-100'
              : 'invisible opacity-0'
          }`}
        >
          {formikSignUpRealestate.errors.logo}
        </span>
      </div>
      <div className="flex w-full items-center gap-4 col-span-2 lg:col-span-1">
        <button type="submit" className="btn btn-primary w-full lg:w-fit">
          تایید و ادامه
        </button>
        <button onClick={() => setStep(1)} className="btn border-[1px] border-primary text-primary w-full lg:w-fit">
          مرحله قبل
        </button>
      </div>
    </form>
  );
}
